/*global jQuery, google */
(function($) {



  'use strict';

  /*
  const $dropdown = $(".dropdown");
  const $dropdownToggle = $(".dropdown-toggle");
  const $dropdownMenu = $(".dropdown-menu");
  const showClass = "show";
  $(window).on("load resize", function() {
    var h = $(window).height()-$('#header').height()-100;
    
    $('.bg_banner').not('.first-bar').height(h+'px');
    console.log($(window).height()-$('#header').height());
    
    if (this.matchMedia("(min-width: 768px)").matches) {
      $dropdown.hover(
        function() {
          const $this = $(this);
          $this.addClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "true");
          $this.find($dropdownMenu).addClass(showClass);
        },
        function() {
          const $this = $(this);
          $this.removeClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "false");
          $this.find($dropdownMenu).removeClass(showClass);
        }
      );
    } else {
      $dropdown.off("mouseenter mouseleave");

      
    }
  });
  */
  $('.back-button').on('click', function() {
    history.go(-1);
  });

  if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
      //$('.nav-link.dropdown-toggle').on('click', function() {
      //  document.location.href = $(this).attr('href');
      //});
  }
  

  $(function() {

    jQuery('li.nav-item').hover(function() {
        jQuery(this).find('.dropdown-menu').addClass('show');
      }, function() {
        jQuery(this).find('.dropdown-menu').removeClass('show');
    });

    
    /*
    var setBackground = function(){
      var $next = $('.link_banner.selected').removeClass('selected').next('.link_banner');
      if ($next.length) {
          $next.addClass('selected'); 
      } else {
          $(".link_banner:first").addClass('selected');
      }

      


      if ($('.link_banner.selected').length) {

        var bg = $('.link_banner.selected').data('bg');
        console.log(bg);

        var _image = new Image();
        _image.id = 'newImageId';
        _image.src = bg;

        $(_image).one("load", function() {
          $('div.bg_banner').css('background-image', 'url(' + bg + ')');
          $('div.bg_banner').fadeTo(2000, 1);
          $('.link_banner').hide();
          $('.link_banner.selected').css({
              "margin-bottom": "40px",
              "margin-left": "-20px",
              "opacity":"0",
              "display":"block",
          }).show().animate({"opacity":1, "margin-left":0})
        });

      }
      //$('.bg_banner').css('background-image', 'url(' + bg + ')');
    }
    $('.link_banner').hide();
    $('.link_banner.selected').show();
    var bg = $('.link_banner.selected').data('bg');
    $('.bg_banner').css('background-image', 'url(' + bg + ')');
    
    setInterval(function(){
      setBackground();
    },5000);
 

    //background: url(../images/Nautico_banner.jpg) no-repeat center center;

    $('body').on('click', '.cerca', function() {
      console.log($('#word').val());
      document.location.href='/it/ricerca/' + $('#word').val();
      gtag('event', 'search', {
        'event_category': 'Ricerca',
        'event_label': $('#word').val()
      });
      
    });

    /*
    $('.owl-carousel.bannerhome').owlCarousel({
      animateOut: 'fadeOut',
      mergeFit: true,
      responsiveRefreshRate: 200,
      margin : 0,
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      autoplaySpeed: 1000,
      items: 1,
      nav: false,
      dots: false,
      //navText:['<div class="left carousel-control hidden-xs"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span></div>',
      //        '<div class="right carousel-control hidden-xs"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></div>']
    });

    $('body').on('change', '.select-tag', function() {
      document.location.href = $(this).find(':selected').data('href');
    });

    $('body').on('click', '.header-phone', function() {
      gtag('event', 'click', {
        'event_category': 'Phone',
        'event_label': 'header-phone'
      });
    });
    */
    /*
    $('body').on('click', '.invia-contatto', function() {
      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nominativo: {
            required: true
          },
          ragsoc: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          telefono: {
            required: true
          },
          localita: {
            required: true
          },
          check_privacy: {
            required: true
          },
        },
        messages: {
          nominativo: {
            required: setup.texts.testi['inserire-nome']
          },
          ragsoc: {
            required: setup.texts.testi['inserire-azienda']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          localita: {
            required: setup.texts.testi['inserire-localita']
          },
          check_privacy: {
            required: setup.texts.testi['check-privacy']
          },
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      
      arr.nominativo = $('#nominativo').val();
      arr.ragsoc = $('#ragsoc').val();
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.localita = $('#localita').val();
      arr.categoriaprodotto = $('#categoriaprodotto').val();
      arr.codiceprodotto = $('#codiceprodotto').val();
      arr.messaggio = $('#messaggio').val();

      arr.check_privacy = $('#check_privacy').is(':checked');
      arr.check_commercial = $('#check_commercial').is(':checked');

      arr.idpagina = $('#idpagina').val();
      arr.pagina = $('#pagina').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>Stiamo elaborando la sua richiesta, attendere un attimo...</h4><br><br>';
        attivaModal(tmpl, null, null);

        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              $('#email').val('');
              $('#nome').val('');
              $('#privacy').val('');
              $('#telefono').val('');
              $('#messaggio').val('');
              $('#captcha').val('');
              gtag('event', 'click', {
                'event_category': 'Contact',
                'event_label': 'compilazione form'
              });
              

            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });


    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };
    */

  });

  


}(jQuery));


function goToElement(element) {
  $("html, body").animate({ scrollTop: $(element).offset().top }, 1000, function(){
    $(element + ' form .form-control' ).addClass('flash');
    $('#nome').focus().trigger('keydown.autocomplete');
    setTimeout(function(){$('.flash').removeClass('flash');}, 1000);

  });
}

